import { normalizeScenario } from './scenario.js';

function dialogueText(cue) {
  if (cue.dialogueText) return cue.dialogueText;
  return cue.type === 'dialogue' ? cue.text : '';
}

export function buildPracticeMoments(input, characterId) {
  const scenario = normalizeScenario(input);
  const characters = new Map(scenario.characters.map((character) => [character.id, character]));
  const moments = [];
  for (let cueIndex = 0; cueIndex < scenario.cues.length; cueIndex += 1) {
    const cue = scenario.cues[cueIndex];
    const lineText = dialogueText(cue);
    if (cue.characterId !== characterId || !lineText) continue;
    let previousDialogue = null;
    for (let previousIndex = cueIndex - 1; previousIndex >= 0; previousIndex -= 1) {
      const previous = scenario.cues[previousIndex];
      const previousText = dialogueText(previous);
      if (!previousText || previous.sceneId !== cue.sceneId) continue;
      previousDialogue = { cue: previous, text: previousText, cueIndex: previousIndex };
      break;
    }
    const leadIn = previousDialogue && previousDialogue.cue.characterId !== characterId ? {
      cueId: previousDialogue.cue.id,
      characterId: previousDialogue.cue.characterId,
      speaker: characters.get(previousDialogue.cue.characterId)?.name || 'Scene partner',
      text: previousDialogue.text,
    } : null;
    moments.push({
      id: `${cue.id}-${cueIndex}`, skillId: `line-${cueIndex}`, cueId: cue.id, cueIndex,
      sceneId: cue.sceneId, characterId, lineText,
      fullDirectionText: cue.directionText || cue.spokenDirectionText || '',
      directionText: cue.directionCaptionOnly === true || cue.spokenDirectionPending === true
        ? cue.directionText || cue.spokenDirectionText || ''
        : cue.spokenDirectionText || cue.directionText || '',
      directionCaptionOnly: cue.directionCaptionOnly === true || cue.spokenDirectionPending === true, leadIn,
    });
  }
  return moments;
}

export function practiceCharacters(input) {
  const scenario = normalizeScenario(input);
  return scenario.characters.filter((character) => buildPracticeMoments(scenario, character.id).length > 0);
}

export function practiceMasteryConfig(moments) {
  return {
    skills: moments.map((moment) => ({ id: moment.skillId, groupId: moment.characterId, minAttempts: 1, recentWindow: 3, masteryRate: 1, maintenanceRate: 0.5 })),
    minAttempts: 1, recentWindow: 3, masteryRate: 1, maintenanceRate: 0.5, maxEvents: 100,
  };
}

export function firstMomentInScene(moments, index) {
  const sceneId = moments[index]?.sceneId;
  const first = moments.findIndex((moment) => moment.sceneId === sceneId);
  return first < 0 ? 0 : first;
}
